import { motion } from "framer-motion";
import { Check, Mail, ShieldCheck, ArrowRight } from "lucide-react";
import { LINKS, PRICE_COMPARISON, ASSETS } from "../data/content";
import { Reveal } from "./Reveal";

const includes = [
  "10 Recorded + 6 LIVE classes",
  "Weekly performance report cards",
  "Personal evaluation by Arpita",
  "Modules, class notes & assignment handbooks",
  "Recordings of every LIVE session",
  "5-week structured 30-day roadmap",
];

const Pricing = () => (
  <section
    id="enrol"
    data-testid="pricing-section"
    className="relative bg-[#f8f9fa] py-24 md:py-32"
  >
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#58cc02] text-center">
          One price. Everything included.
        </p>
        <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tight text-center mt-4 text-[#111827]">
          Topper-level coaching, without the topper-level bill.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-14 grid lg:grid-cols-12 gap-6 items-stretch">
          {/* Price comparison */}
          <div className="lg:col-span-5 rounded-3xl bg-white border border-black/5 p-8 md:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <h3 className="font-display font-extrabold text-xl text-[#111827]">
              What famous coachings charge
            </h3>
            <div className="mt-6 space-y-3">
              {PRICE_COMPARISON.map((p) => (
                <div
                  key={p.label}
                  className="flex items-center justify-between rounded-2xl bg-[#f8f9fa] px-5 py-4"
                >
                  <span className="font-semibold text-[#4b5563]">{p.label}</span>
                  <s className="font-display font-extrabold text-xl text-[#ef4444]">
                    {p.price}
                  </s>
                </div>
              ))}
            </div>
            <div className="mt-6 rounded-2xl bg-[#e5f7d6] px-5 py-5 flex items-center justify-between">
              <span className="font-bold text-[#46a302]">Essay Advantage Club</span>
              <span className="font-display font-black text-3xl text-[#46a302]">
                ₹1,100
              </span>
            </div>
          </div>

          {/* Main card */}
          <div className="lg:col-span-7 rounded-3xl bg-[#0a0a0a] text-white p-8 md:p-12 relative overflow-hidden">
            <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[#58cc02]/25 blur-2xl" />
            <div className="relative">
              <div className="flex items-center gap-4">
                <img
                  src={ASSETS.logo}
                  alt="Essay Advantage Club"
                  className="h-16 w-16 rounded-full"
                />
                <div>
                  <p className="text-sm uppercase tracking-[0.2em] text-[#8ee85a] font-bold">
                    30-Day Essay Advantage
                  </p>
                  <div className="flex items-baseline gap-3">
                    <span className="font-display font-black text-5xl md:text-6xl">
                      ₹1,100
                    </span>
                    <s className="text-white/40 font-bold text-xl">₹12,000</s>
                  </div>
                </div>
              </div>

              <ul className="mt-8 grid sm:grid-cols-2 gap-3">
                {includes.map((it) => (
                  <li key={it} className="flex items-start gap-2 text-white/85">
                    <span className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-[#58cc02] flex items-center justify-center">
                      <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
                    </span>
                    <span className="text-sm font-semibold leading-snug">{it}</span>
                  </li>
                ))}
              </ul>

              <a
                href={LINKS.enrol}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pricing-enrol-button"
                className="btn-3d group mt-9 w-full bg-[#58cc02] text-white font-extrabold text-lg px-8 py-5 rounded-2xl uppercase tracking-wide flex items-center justify-center gap-2"
              >
                Enrol Now — ₹1,100
                <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
              </a>

              <div className="mt-6 rounded-2xl bg-white/5 border border-white/10 p-5">
                <div className="flex items-center gap-2 text-[#8ee85a] font-bold text-sm">
                  <ShieldCheck className="h-5 w-5" />
                  Important — how to get access
                </div>
                <p className="mt-2 text-sm text-white/70 leading-relaxed">
                  After payment, email your receipt to{" "}
                  <a
                    href={LINKS.email}
                    data-testid="pricing-email-link"
                    className="text-white font-bold underline decoration-[#58cc02] underline-offset-2 inline-flex items-center gap-1"
                  >
                    <Mail className="h-4 w-4" /> {LINKS.emailPlain}
                  </a>
                  . Our team verifies every receipt before adding you to the club.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
